import React from 'react';
import { FlowBlockCustomerContact as BlockModel } from '@staffino/model';
import { CustomerContactBlock as Component } from '@staffino/flow-controls';

type Props = {
  block: BlockModel;
};

const CustomerContactBlock = ({ block }: Props) => {
  return <Component block={{ ...block }} />;
};

export default CustomerContactBlock;
